
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { FontIcon } from "office-ui-fabric-react";

import { DialogAlert } from '../common/client/components/DialogAlert';
import DialogConfirm from '../common/client/components/DialogConfirm';
import Routes from '../common/client/components/Routes';

import { getErrorMessage, getProjectSaveData } from './../reducers/project';

import mapGetActions from './../sagas/map';
import projectGetActions from './../sagas/project';

import { PAGE_USEK_INPUT, redirectToPage } from './pagesDefinition';
import PageFooter from './common/PageFooter.view';
import PageHeader from './common/PageHeader.view';
import { PAGES } from './pagesDefinition';

import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    root: {
        width: '100vw',
        height: '100vh'
    },

    heading: {
        backgroundColor: '#999999',
        color: '#000000',
        padding: '0em 1em',
        display: 'flex',
        justifyContent: 'space-between'
    },

    content: {
        height: '100%',
        overflowY: 'auto',
        display: 'flex',
        justifyContent: 'center'
    }
});

const iconClass = mergeStyleSets({
    ico: {
        fontSize: 32,
        paddingTop: 20,
    }
});

const ProjectBasePage = (props) => {

    const dispatch = useDispatch();
    const mapActions = mapGetActions(dispatch);
    const projectActions = projectGetActions(dispatch);

    const projectSaveData = useSelector(state => getProjectSaveData(state.project));
    const errorMessage = useSelector(state => getErrorMessage(state.project));

    const handleGetProjectSaveData = () => {
        return projectSaveData;
    }

    const handleNewClick = async () => {
        let confirm = await DialogConfirm.show(`Všechna neuložná data budou ztracena. Opravdu chcete pokračovat na novou kalkulaci?`);
        if (confirm) {
            projectActions.clear();
            mapActions.reset();
            redirectToPage(PAGE_USEK_INPUT);
        }
    }

    const handleOpenProject = (file) => {
        let reader = new FileReader();
        reader.onload = () => {
            let data = reader.result;
            projectActions.readProject(data);
            redirectToPage(PAGE_USEK_INPUT);
        };
        reader.readAsText(file);
    }

    const handleCancelError = () => {
        projectActions.setErrorMessage(null);
    }

    const getActualPage = () => {
        return PAGES.reduce((previous, current) => {
            return (current.pathname === props.location.pathname)
                ? current.id
                : previous;
        }, -1);
    }

    const renderErrorMessage = () => {
        return (
            <DialogAlert
                show={true}
                message={errorMessage}
                onCancel={handleCancelError}
            />
        );
    }

    return (
        <Stack className={classNames.root}>
            <Stack.Item horizontal className={classNames.heading}>
                <h1>Kalkulátor mezí</h1>
                <FontIcon iconName="Calculator" className={iconClass.ico}></FontIcon>
            </Stack.Item>
            <Stack.Item>
                <PageHeader actualPage={getActualPage()} />
            </Stack.Item>
            <Stack.Item grow id={'content'} className={classNames.content}>
                <Routes routes={props.routes} />
            </Stack.Item>
            <Stack.Item>
                <PageFooter
                    onNewClick={handleNewClick}
                    onGetSaveData={handleGetProjectSaveData}
                    onProcessOpenFile={handleOpenProject}
                />
            </Stack.Item>
            {errorMessage && renderErrorMessage()}
        </Stack>
    );
};

export default ProjectBasePage;
